import React, { useId } from 'react';

const defaultShadow = {
  dx: 0,
  dy: 1.25,
  stdDeviation: 1.15,
  floodColor: '#0f172a',
  floodOpacity: 0.14,
};

/**
 * Rounded horizontal slats from precomputed rects (raster pipeline).
 *
 * @param {object} props
 * @param {Array<{ x: number, y: number, w: number, h: number, rx: number, opacity?: number }>} props.rects
 * @param {number} props.viewBoxSize
 * @param {boolean} [props.dropShadow]
 * @param {object} [props.svgAttrs]
 */
export function SlatSilhouetteSvg({ rects, viewBoxSize, dropShadow = true, svgAttrs = {} }) {
  const reactId = useId().replace(/:/g, '');
  const filterId = `slat-silhouette-shade-${reactId}`;
  const vb = viewBoxSize;

  const body = rects.map((r, i) => (
    <rect
      key={`slat-${i}`}
      x={r.x}
      y={r.y}
      width={r.w}
      height={r.h}
      rx={r.rx}
      ry={r.rx}
      fill="currentColor"
      fillOpacity={r.opacity ?? 1}
    />
  ));

  if (!dropShadow) {
    return (
      <svg viewBox={`0 0 ${vb} ${vb}`} xmlns="http://www.w3.org/2000/svg" {...svgAttrs}>
        {body}
      </svg>
    );
  }

  return (
    <svg viewBox={`0 0 ${vb} ${vb}`} xmlns="http://www.w3.org/2000/svg" {...svgAttrs}>
      <defs>
        <filter
          id={filterId}
          x="-25%"
          y="-25%"
          width="150%"
          height="150%"
          colorInterpolationFilters="sRGB"
        >
          <feDropShadow
            dx={defaultShadow.dx}
            dy={defaultShadow.dy}
            stdDeviation={defaultShadow.stdDeviation}
            floodColor={defaultShadow.floodColor}
            floodOpacity={defaultShadow.floodOpacity}
          />
        </filter>
      </defs>
      <g filter={`url(#${filterId})`}>{body}</g>
    </svg>
  );
}
